import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalysisFinishComponent } from '@modules/analysis/components/analysis-finish/analysis-finish.component';
import * as AnalysisState from '@modules/analysis/_store';
import { CommonService } from '@modules/audit/services/audit.service';
import * as AuditState from '@modules/audit/_store';
import { select, Store } from '@ngrx/store';
import { AnalysisService } from '@services/analysis/analysis.service';
import { EventsService } from '@services/analysis/events.service';
import { Observable } from 'rxjs';
import { filter, map, tap, first } from 'rxjs/operators';
import { AnalysisDocument } from 'src/app/shared/interface/analysis';
import { Timer } from './header-timer';

@Component({
  selector: 'analysis-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  analysis$: Observable<any>;
  module = 'audit_module' || 'analysis_module';
  module_str: string;

  id?: string;
  status?: string;
  dialogFinish: MatDialogRef<AnalysisFinishComponent>;
  disableFinish = true;
  disableClose = false;

  timer: Timer;

  openedMenu: boolean;
  candidateName: string;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private store: Store,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private eventsService: EventsService,
    private analysisService: AnalysisService
  ) {
    this.analysisService.name$.subscribe(
      (name) => this.candidateName = name
    )
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((param) => {
      if (param['id']) {
        this.analysis$ = this.getHeaderContent(AnalysisState);
        this.getStatusDocuments().subscribe();
      } else {
        this.analysis$ = null;
      }
    });

    this.commonService.currentModule.pipe(filter((module) => !!module))
      .subscribe(module => {
        this.getContent(module);
      })
  }

  openMenu(value: boolean): void {
    this.openedMenu = value;
  }

  // function that closes the analysis and audit header
  closeAnalysis(): void {
    this.timer.stop();

    this.eventsService
      .dispatchEvents(this.module_str, [{ kind: 'analysis_withdrawal', key: '-', data: {} }])
      .subscribe(() => this.router.navigate(['']));
  }

  openDialog(param?: boolean): void {
    this.dialogFinish = this.dialog.open(AnalysisFinishComponent, {
      disableClose: false,
      data: param
    });

    if (!param) {
      this.dispatchAnalysisEnding('analysis_timeout');
    }

    this.dialogFinish.afterClosed().subscribe(response => {
      if (response?.finalize) {
        this.timer.stop();
        this.dispatchAnalysisEnding('analysis_finish'), this.router.navigateByUrl('/');
      }
    });
  }

  private getContent(module: string): void {
    this.module = module;

    const i = this.module.indexOf('_');
    this.module_str = this.module.replace(this.module.substr(i), '');

    if (module === 'analysis_module') {
      // TODO: handle both analysis_module and audit_module when fetching the header contents
      // this.activatedRoute.queryParams.subscribe((param) => {

      //   if (param['id']) {
      //     this.analysis$ = this.getHeaderContent(AnalysisState);
      //     this.getStatusDocuments().subscribe();
      //   } else {
      //     this.analysis$ = null;
      //   }
      // });
    } else if (module === 'audit_module') {
      this.getHeaderContent(AuditState);
    }
  }

  private getHeaderContent(state): Observable<any> {
    return this.store.pipe(
      select(state.getInfos),
      filter(val => val !== null),
      first(),
      map((response: any) => {
        const { id, topic, time_left, profile, candidateName } = response;
        this.id = id;
        this.analysisService.name$.next(candidateName);

        this.setHeaderInfo(topic)

        const [minutes, seconds] = time_left.split(/[a-zA-Z]/)

        this.timer = new Timer(minutes, seconds)
        this.timer.start();
        this.timer.onTimeout().subscribe(() => this.openDialog());

        return {
          profile,
          time_left,
          topic,
        };
      }));
  }

  private setHeaderInfo(topic: string): void {
    this.status = this.parseStatus(topic);
  }

  private dispatchAnalysisEnding(kind: string): void {
    this.store.dispatch(
      AnalysisState.timeoutAnalysis({
        module: this.module_str,
        payload: { kind, key: '-', data: {} },
      })
    );
  }

  private parseStatus(topic: string): string {
    const status = {
      analysis: () => 'Análise',
      reanalysis: () => 'Reanálise',
      auditoria: () => 'Auditoria'
    };

    return status[topic]() || 'Análise';
  }

  private getStatusDocuments(): Observable<AnalysisDocument> {
    return this.store.pipe(
      select(AnalysisState.getModuleDocuments),
      filter((documents) => !!documents),
      tap((documents) => {
        const arr = Object.keys(documents).map((key) => {
          const document = documents[key];

          // removing disregarded documents from the list
          if (document?.dismissed || document?.key === 'esocial_module') { return; }

          return document?.status;
        });

        // We need to redefine disableFinish everytime, or else it will always keep the same value the last analysis left
        this.disableFinish = true

        if (arr.length > 0 && arr.every((status) => status !== 'pending' && status !== 'not_validated')) {
          this.disableFinish = false;
        }
      })
    );
  }
}
